import React, { useEffect, useRef } from "react";
import Button from "../../components/common/ui/Button";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions, masterActions, photoAction } from "../../_store";
import InfoIcon from "../../assets/svg/information-icon.svg";
import { CheckBoxInput } from "../../components/common/ui/Inputs";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import { history } from "../../_helpers";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import { StoredProcedures } from "../../_helpers/enumerator";
// import Table from "../../components/common/table/Table";
import CustomPhoto from "../../composables/CustomPhoto";
import CustomLoader from "../../components/common/ui/Loader";
import { useLocation } from "react-router-dom";
import { getStoredValue } from "../../_helpers/storagehelper";
import { formatDate } from "../../utils/formatTime";

function MultiPhotosApproval() {
  const dispatch = useDispatch();

  const {
    multiphotosSearchData,
    photosSearchData,
    photosList,
    LoadReviewALLPhotosListNewData,
    loading,
    multiplePhotoStateList
  } = useSelector((x) => x?.photos);
  const { commonFacilityCode } = useSelector((state) => state.auth);
  const user = useSelector((x) => x.auth.user);
  const { commonFacilityCode: facilityCode } = useSelector(
    (state) => state.auth
  );

  const [isapicalldisabled, setisactiondisabled] = useState(false);
  const MultiphotoRef = useRef(null);
  const prevFacilityCodeRef = useRef(facilityCode);
  const isCallingAPI = useRef(false);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);
  const [selectedPhoto, setSelectedPhoto] = useState("");
  const [approveRejectStatus, setApproveRejectStatus] = useState({
    photoCommID: [],
    facilityID: commonFacilityCode,
    photoApprove: 0,
    photoReject: 0,
    createdBy: getStoredValue("user")?.ManagementUserID,
  });
  const [isZoom, setIsZoom] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const location = useLocation();
  const [photoList, setPhotoList] = useState(multiplePhotoStateList || []);
  const [hasMoreData, setHasMoreData] = useState(
    multiplePhotoStateList?.length > 0 &&
      multiplePhotoStateList[0]?.TotalPhotoCount > 8
      ? true
      : false
  );
  const [photoLoader, setPhotoLoader] = useState(false);
  const [showTopButton, setShowTopButton] = useState(false);
  const { isSignalRData } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, []);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate("PhotoList");
    }
  }, [facilityCode]);

  useEffect(() => {
    const search = {
      ...multiphotosSearchData,
    };
    if (multiphotosSearchData?.isPageRefresh === false) return;
    if (search?.isPageRefresh === true) {
      history?.navigate("PhotoList");
    }
  }, []);

  //signalR
  useEffect(() => {
    switch (isSignalRData?.type) {
      case 'Reject_Photo':
      case 'Approve_Photo':
        if (isSignalRData?.user !== user?.ManagementUserID) {
          var photoLists = photoList?.filter((x) => x?.PhotoCommID !== isSignalRData?.message?.PhotoCommID);
          setPhotoList(photoLists);
        }
        break;
    }
  }, [isSignalRData]);



  const data = [
    {
      label: "From",
      value: photoList?.[selectedPhotoIndex]?.PhotoFrom || "-",
    },
    {
      label: "To",
      value: photoList?.[selectedPhotoIndex]?.PhotoTo || "-",
    },
    {
      label: "Subject",
      value: photoList?.[selectedPhotoIndex]?.PhotoSubject || "",
    },
    {
      label: "Date",
      value: formatDate(photoList?.[selectedPhotoIndex]?.PhotoSentDate) || "",
    },

    {
      label: "Photo",
      value: (
        <img
          height={"100px"}
          width={"100px"}
          style={{ objectFit: "contain" }}
          src={photoList?.[selectedPhotoIndex]?.IsPhotoBinarySave == 1 ? `data:image/png;base64, ${photoList?.[selectedPhotoIndex]?.PhotoBinaryData}` : photoList?.[selectedPhotoIndex]?.PhotoAttachPath}
          alt=""
        />
      ),
    },
  ];

  const handleZoom = (photo) => {
    setSelectedPhoto(photo);
    setIsZoom(true);
  };

  const handleCheck = (e, index) => {
    const { checked } = e?.target;
    const data = [...photoList];
    // const dataList = [...photoList?.DataList];

    data[index] = {
      ...data[index],
      isChecked: checked,
    };
    setPhotoList(data);
    //check all attributes are true //ischecked === true
    const isSelectAll = data?.every((item, index) => item?.isChecked === true);
    setSelectAllChecked(isSelectAll);
    // data.DataList = dataList;
    const selectedPhotos = data?.filter((photo) => photo?.isChecked);
    const splitPhotoId = selectedPhotos?.map((photo) => photo?.PhotoCommID);
    const status = { ...approveRejectStatus };
    status.photoCommID = splitPhotoId;
    setApproveRejectStatus(status);
    // dispatch(photoAction?.updateMultiPhotoData(data));
  };

  const handleselectCheck = (e, groupIndex) => {
    const { checked } = e?.target;

    // Clone and update the photo list
    const updatedPhotoList = photoList.map((photo, index) => {
      const isInGroup = index >= groupIndex * 4 && index < groupIndex * 4 + 4;
      return isInGroup ? { ...photo, isChecked: checked } : photo;
    });

    setPhotoList(updatedPhotoList);

    // Update approve/reject status with selected PhotoCommIDs
    const selectedPhotos = updatedPhotoList?.filter(
      (photo) => photo?.isChecked
    );
    const splitPhotoId = selectedPhotos?.map((photo) => photo?.PhotoCommID);
    const status = { ...approveRejectStatus };
    status.photoCommID = splitPhotoId;
    setApproveRejectStatus(status);
  };

  const handleApproveOrReject = (status) => {
    if (approveRejectStatus?.photoCommID?.length === 0) {
      showToastNotification("Please select Atleast one Photo", "error");
      return;
    }

    Popup({
      title: "Message",
      text: `Are you sure you want to ${status === 1 ? "approve" : "reject"} ${approveRejectStatus?.photoCommID?.length
        } ${approveRejectStatus?.photoCommID?.length > 1 ? " photos" : " photo"
        }?`,
      icon: "info",
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        const payload = { ...approveRejectStatus };
        payload.photoApprove = status === 1 ? 1 : 0;
        payload.photoReject = status === 1 ? 0 : 1;
        setPhotoLoader(true);
        dispatch(photoAction?.updateStatusNew(payload))
          .then((result) => {
            const status = { ...approveRejectStatus };
            status.photoCommID = [];
            setApproveRejectStatus(status); //for disb
            const payloadCommID = result?.meta?.arg?.photoCommID;
            const res = result?.payload;
            const updatedTotalRowCount =
              photoList?.length > 8 ? photoList?.length - 1 : 8;
            switch (res?.IsSucceed) {
              case 1:
                // Insert Management User Activity Log
                dispatch(
                  authActions?.ManagementUserActivityLog({
                    ManagementUserID: user?.ManagementUserID,
                    facilityID: commonFacilityCode,
                    ProcedureName: StoredProcedures?.PhotoApproveOrReject,
                    UserAction: `Approved Photo ( PhotoCommID - ${payloadCommID} )`,
                  })
                );

                showToastNotification(
                  "Photo Approved Successfully.",
                  "success"
                );

                // setTotalRecordCount(updatedTotalRowCount);
                const search = {
                  ...multiphotosSearchData,
                  facilityID: commonFacilityCode,
                  pageNo: 1,
                  rowCountPerPage: updatedTotalRowCount,
                  photoActionStatus: 3,
                  isReviewPhotos: true,
                };
                dispatch(photoAction?.LoadReviewALLPhotosListNew(search))
                  .then((result) => {
                    if (result?.payload) {
                      setPhotoLoader(false);
                      setPhotoList(result?.payload?.DataList);
                    }
                  })
                  .catch((err) => {
                    setPhotoLoader(false);
                  });
                setSelectAllChecked(false);
                break;

              case 2:
                // Insert Management User Activity Log
                dispatch(
                  authActions?.ManagementUserActivityLog({
                    ManagementUserID: user?.ManagementUserID,
                    facilityID: commonFacilityCode,
                    ProcedureName: StoredProcedures?.PhotoApproveOrReject,
                    UserAction: `Rejected Photo ( PhotoCommID - ${payloadCommID} )`,
                  })
                );

                showToastNotification(
                  "Photo rejected Successfully..",
                  "success"
                );
                const searchData = {
                  ...multiphotosSearchData,
                  pageNo: 1,
                  facilityID: commonFacilityCode,
                  // rowCountPerPage: photoList?.length,
                  rowCountPerPage: updatedTotalRowCount,
                  photoActionStatus: 3,
                  isReviewPhotos: true,
                };
                dispatch(photoAction?.LoadReviewALLPhotosListNew(searchData))
                  .then((result) => {
                    if (result?.payload) {
                      setPhotoLoader(false);
                      setPhotoList(result?.payload?.DataList);
                    }
                  })
                  .catch((err) => {
                    setPhotoLoader(false);
                  });
                setSelectAllChecked(false);
                break;

              case -1:
                // history.navigate("/Admin/PhotoList");
                showToastNotification("Insert Failed", "error");
                setPhotoLoader(false);
                break;

              case -2:
                // history.navigate("/Admin/PhotoList");
                showToastNotification("Already Approved or Rejected.", "error");
                setPhotoLoader(false);
                break;


              case -3:
                showToastNotification("Photo already approved.", "error");
                history.navigate("/Admin/PhotoList");
                dispatch(photoAction.resetForm());
                break;

              case -4:
                showToastNotification("Photo already Rejected.", "error");
                history.navigate("/Admin/PhotoList");
                dispatch(photoAction.resetForm());
                break;

              default:
                break;
            }
            dispatch(
              masterActions.GetLoadNotificationAlert({
                ManagementUserID: user.ManagementUserID,
                FacilityID: commonFacilityCode,
              })
            ).then((response) => {
              const updatedMenuList =
                getStoredValue("menu_list") ||
                response?.payload;

              if (updatedMenuList) {
                dispatch(authActions.updateMenuList(updatedMenuList));
              }
            });
          })
          .catch((err) => {
            showToastNotification(err?.message, "error");
            setPhotoLoader(false);
          });
      },
    });
  };

  const handleBack = (e) => {
    const searchData = { ...photosSearchData };
    searchData.facilityID = commonFacilityCode;
    // searchData.pageNo = 1;
    //searchData.rowCountPerPage = 10;
    dispatch(photoAction?.setPhotosSearch(searchData));
    history.navigate("/Admin/PhotoList");
  };


  useEffect(() => {
    const handleScroll = async () => {
      if (!hasMoreData || isCallingAPI.current || isapicalldisabled) return;

      const container = MultiphotoRef.current;
      if (!container) return;

      const { scrollTop, scrollHeight, clientHeight } = container;
      //const isAtBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight - 5;

      const isAtBottom = scrollTop > 0 && scrollHeight - scrollTop - clientHeight <= 5 && scrollTop + clientHeight <= scrollHeight + 1;

      if (isAtBottom) {
        isCallingAPI.current = true; // Lock

        const search = {
          ...multiphotosSearchData,
          facilityID: commonFacilityCode,
          rowCountPerPage: 8,
          photoActionStatus: 3,
          pageNo: (multiphotosSearchData?.pageNo || 1) + 1,
        };

        try {
          await dispatch(photoAction?.LoadReviewALLPhotosListNew(search)).then((result) => {
            if (result?.payload) {
              const updatedArr = [...photoList, ...result.payload.DataList];
              const uniqueArr = Array.from(
                new Map(updatedArr.map(item => [item.PhotoCommID, item])).values()
              );
              if (uniqueArr.length >= result.payload.TotalRecordCount) {
                setHasMoreData(false);
              }
              setPhotoList(uniqueArr);
            }
          })
        } catch (err) {
          console.error(err.message);
          showToastNotification("Failed to get Photo List");
        } finally {
          isCallingAPI.current = false; // Unlock
          dispatch(photoAction?.setmultiPhotosSearch(search));
        }
      }
    };

    const refCurrent = MultiphotoRef.current;
    if (refCurrent) {
      refCurrent.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener("scroll", handleScroll);
      }
    };
  }, [hasMoreData, photoList, multiphotosSearchData, dispatch, commonFacilityCode]);


  useEffect(() => {
    const handleScroll = () => {
      if (MultiphotoRef.current?.scrollTop > 100) {
        setShowTopButton(true);
      } else {
        setShowTopButton(false);
      }
    };

    const refElement = MultiphotoRef.current;
    if (refElement) {
      refElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (refElement) {
        refElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const scrollToTop = () => {
    if (MultiphotoRef.current) {
      MultiphotoRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: "Arial, sans-serif",
    border: "1px solid #ddd",
  };

  const cellLabelStyle = {
    padding: "10px",
    width: "40%",
    border: "1px solid #ddd",
    verticalAlign: "top",
  };

  const cellValueStyle = {
    padding: "10px",
    border: "1px solid #ddd",
  };

  // const [imageLoading, setImageLoading] = useState({});

  // const handleImageLoad = (index) => {
  //   setImageLoading((prev) => ({
  //     ...prev,
  //     [index]: false,
  //   }));
  // };

  // const handleImageStart = (index) => {
  //   setImageLoading((prev) => ({
  //     ...prev,
  //     [index]: true,
  //   }));
  // };

  if (photoLoader) return <CustomLoader />;

  return (
    <div className="multiPhotoContainer card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
      <div className=" d-flex flex-wrap justify-content-between flex-wrap resp-space">
        <h2 className="text-color">Approve / Reject Photos</h2>
        <div className="d-flex gap-3 justify-content-center align-items-center">
          <Button
            label="Approve"
            status="success"
            type="button"
            icon="fa-solid fa-circle-check"
            disabled={approveRejectStatus?.photoCommID?.length === 0}
            onClick={() => handleApproveOrReject(1)}
          />
          <Button
            label="reject"
            icon="fa-solid fa-window-close"
            status="primary"
            type="button"
            disabled={approveRejectStatus?.photoCommID?.length === 0}
            onClick={() => handleApproveOrReject(0)}
          />
          <Button
            label="back"
            icon={"fa-solid fa-angle-left"}
            status="primary"
            type="button"
            onClick={(e) => handleBack(e)}
          />
        </div>
      </div>

      <div
        className="p-4  w-100"
        ref={MultiphotoRef}
        style={{ maxHeight: "80vh", overflowY: "auto", WebkitOverflowScrolling: "touch" }}>

        <div className="w-100">
          {photoList?.length > 0 ? (
            <>
              <div className="row">
                {photoList &&
                  photoList.length > 0 &&
                  [...Array(Math.ceil(photoList.length / 4))].map(
                    (_, groupIndex) => (
                      <div
                        className={`row visitors-list  ${groupIndex % 2 === 1 ? "visitor-request-form " : ""
                          }`}
                        key={groupIndex}
                      >
                        <div className="d-flex justify-content-end mb-2 d-none d-md-flex">
                          <CheckBoxInput
                            label="Select row"
                            name="photo"
                            id={`photo-${(groupIndex * 4, groupIndex * 4 + 4)}`}
                            handleClick={(e) =>
                              handleselectCheck(e, groupIndex)
                            }
                            checked={photoList
                              .slice(groupIndex * 4, groupIndex * 4 + 4)
                              .every((photo) => photo?.isChecked)}
                          />
                        </div>
                        <div className="row">
                          {photoList
                            .slice(groupIndex * 4, groupIndex * 4 + 4)
                            .map((photo, index) => {
                              const actualIndex = groupIndex * 4 + index;

                              const imgSrc = photo?.IsPhotoBinarySave == 1 ? `data:image/png;base64,${photo?.PhotoBinaryData}` : photo?.PhotoAttachPath;

                              return (
                                <div
                                  className="col-md-3 col-sm-6 col-12 photo-on-hover mb-3"
                                  key={actualIndex}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "250px",
                                      position: "relative",
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                      cursor: "pointer",
                                    }}
                                    className="multiphoto-anime"
                                    onClick={() => handleZoom(photo)}
                                  >
                                    {/* Loader */}
                                    {/* {imageLoading[actualIndex] !== false && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          width: "100%",
                                          height: "100%",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          background: "#f5f5f5",
                                          zIndex: 1,
                                        }}
                                      >
                                        Loading...
                                      </div>
                                    )} */}

                                    {/* Image */}
                                    <img
                                      src={imgSrc}
                                      alt=""
                                      loading="lazy"
                                      // onLoad={() => handleImageLoad(actualIndex)}
                                      //    onError={() => handleImageLoad(actualIndex)}
                                      //  onLoadStart={() => handleImageStart(actualIndex)}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                        //display: imageLoading[actualIndex] === false ? "block" : "none",
                                      }}
                                    />
                                  </div>

                                  <div className="gap-2 fw-bold d-flex flex-wrap justify-content-between align-items-end mt-2">
                                    <CheckBoxInput
                                      label="Select"
                                      name="photo"
                                      id={`photo-${photo?.PhotoCommID}`}
                                      handleClick={(e) =>
                                        handleCheck(e, actualIndex)
                                      }
                                      checked={photo?.isChecked}
                                    />
                                    <img
                                      className="photo-info-icon"
                                      src={InfoIcon}
                                      title="Info"
                                      data-bs-toggle="modal"
                                      data-bs-target="#multi-photo-modal"
                                      alt="info-icon"
                                      onClick={() =>
                                        setSelectedPhotoIndex(actualIndex)
                                      }
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          {/* {photoList
                            .slice(groupIndex * 4, groupIndex * 4 + 4)
                            .map((photo, index) => {
                              const actualIndex = groupIndex * 4 + index;
                              return (
                                <div
                                  className="col-md-3 col-sm-6 col-12 photo-on-hover mb-3"
                                  key={actualIndex}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "250px",
                                      backgroundImage: photo?.IsPhotoBinarySave == 1
                                        ? `url('data:image/png;base64,${photo?.PhotoBinaryData}')`
                                        : `url(${photo?.PhotoAttachPath})`,
                                      backgroundSize: "contain",
                                      backgroundPosition: "center",
                                      backgroundRepeat: "no-repeat",
                                      cursor: "pointer",
                                      borderRadius: "8px",
                                    }}
                                    className="multiphoto-anime"
                                    onClick={() =>
                                      handleZoom(photo)
                                    }
                                  />
                                </div>
                              );
                            })} */}
                        </div>
                      </div>
                    )
                  )}
              </div>

              {hasMoreData && (
                <div className="d-flex justify-content-center">
                  <i class="fas fa-spinner fa-spin fs-2"></i>
                </div>
              )}
            </>
          ) : (
            <div className="table-no-data-text mt-5 fs-4 mb-5 text-center fw-bold">
              There are no pending photos for approval or rejection.
            </div>
          )}
        </div>
      </div>
      {showTopButton && (
        <button
          className="scroll-to-top-btn"
          onClick={scrollToTop}
          title="Back to Top"
        >
          <i className="fa-regular fa-circle-up"></i>
        </button>
      )}
      <CustomPhoto
        imgsrc={
          selectedPhoto?.IsPhotoBinarySave == 1 ? "data:image/png;base64," + selectedPhoto?.PhotoBinaryData : selectedPhoto?.PhotoAttachPath
        }
        isZommImage={isZoom}
        setisZommImage={setIsZoom}
        rotation={rotation}
        setRotation={setRotation}
      />
      {photoList?.length > 0 && (
        <CommonModal
          modalId="multi-photo-modal"
          title="PHOTO INFORMATION"
          modalSize="modal-md"
          bodyContent={
            <>
              <div className="d-flex flex-wrap justify-content-end align-items-end mb-3">
                {/* <Table columns={columns} data={data} /> */}
                <table style={tableStyle}>
                  <tbody>
                    {data.map((row, index) => (
                      <tr
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                        }}
                      >
                        <td className="doc-name" style={cellLabelStyle}>
                          {row.label}
                        </td>
                        <td style={cellValueStyle}>{row.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          }
          footerContent={
            <button className="btn button-primary" data-bs-dismiss="modal">
              Close
            </button>
          }
        />
      )}
    </div>
  );
}

export default React.memo(MultiPhotosApproval);
